var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, _vm._l(_vm.$store.state.productStates, function (state) {
    return _c('b-button', {
      key: state.identifier,
      staticClass: "d-block w-100 mb-3",
      attrs: {
        "variant": "primary",
        "disabled": !!_vm.isProcessing
      },
      on: {
        "click": function ($event) {
          return _vm.submit(state.identifier);
        }
      }
    }, [_vm._v(" " + _vm._s(state.display_name) + " "), state.identifier === _vm.isProcessing ? _c('font-awesome-icon', {
      staticClass: "ml-2",
      attrs: {
        "icon": "spinner",
        "spin": ""
      }
    }) : _vm._e()], 1);
  }), 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }